import Vue from 'vue';
import store from './../../store';
import languageTransformer from './../../transformers/language';

const success = ({ data }, resolve) => {
  const languages = languageTransformer.fetchCollection(data.data);
  store.dispatch('fetchLanguages', languages);
  resolve(languages);
};

const failed = () => {
};


export default () => (
  new Promise((resolve, reject) => {
    Vue.$http.get('/account/languages')
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/account/languages.js